import React from "react";
import {AOperation} from "../../../models/operations/AOperation";
import {IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle} from "@ionic/react";
import ActionButtons from "./actionButtons/ActionButtons";
import DisplayOperation from "../../display/operation/DisplayBasicOperation";
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    operation: AOperation,
    color?: string
}

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 31/05/2022
 * @last_update 31/05/2022
 **/
class ModalInPopup extends React.Component<Props> {

    render() {

        /**
* Retrieves from the props the function to access the translation.
**/
const getTranslation = this.props.t;

        return (

            <IonCard color={this.props.color}>
                <IonCardHeader>
                    <IonCardSubtitle>
                        {
                            getTranslation("pages.map.marker.modal.title")
                        }
                        &nbsp;
                        {
                            (this.props.operation.isSynchro ?
                                getTranslation("pages.map.marker.modal.sync") :
                                getTranslation("pages.map.marker.modal.async")
                            )
                        }
                    </IonCardSubtitle>
                    <IonCardTitle>
                        <b>{getTranslation("pages.map.marker.modal.title")} n°{this.props.operation.id}</b>
                    </IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                    <div style={{height: "40vh", overflow: "auto"}}>
                        {
                            <DisplayOperation operation={this.props.operation}/>
                        }
                    </div>
                    {
                        !this.props.operation.isSynchro ? <ActionButtons operation={this.props.operation}/> : ""
                    }
                </IonCardContent>
            </IonCard>

        );

    };

}

export default withTranslation()(ModalInPopup);
